import { useLazyQuery as useApolloLazyQuery } from '@apollo/react-hooks';

const useLazyQuery = (...args) => (
  useApolloLazyQuery(...args)
);

export default useLazyQuery;
